export default __webpack_public_path__ + "static/media/profile.ad69ced1.jpg";